module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row1_certificate.631dc390.png";